import { render, staticRenderFns } from "./Voice.vue?vue&type=template&id=d6e9b568&scoped=true&"
import script from "./Voice.vue?vue&type=script&lang=js&"
export * from "./Voice.vue?vue&type=script&lang=js&"
import style0 from "./Voice.vue?vue&type=style&index=0&id=d6e9b568&prod&lang=scss&"
import style1 from "./Voice.vue?vue&type=style&index=1&id=d6e9b568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e9b568",
  null
  
)

export default component.exports